import { render } from "./UpdateLog.vue?vue&type=template&id=9ae749d8"
import script from "./UpdateLog.vue?vue&type=script&lang=js"
export * from "./UpdateLog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Midea\\Desktop\\产品管理系统\\ProductManager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__